/* jshint esversion: 6 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue';
import _ from 'lodash'
import Cons from '@/constants.json'

export default {
    namespaced: true,
    state: {
        stat: {
            data: {},
            isLoading: false
        }
    },
    getters: {},
    mutations: {
        setIsLoadingStat(state, v) {
            Vue.set(state.stat, 'isLoading', v);
        },
        populateBrandStat(state, v) {
            Vue.set(state.stat, 'data', v);
        }
    },
    actions: {
        getStats({ commit, dispatch }, { id }) {
            commit('setIsLoadingStat', true);
            return Axios.get(API.endpoints.careplan + '/' + id + '/subscribers/summary')
                .then(result => {
                    commit('populateBrandStat', result.data);
                    commit('setIsLoadingStat', false);
                    return Promise.resolve(result)
                })
                .catch(_err => {
                    dispatch('exceptionHandling', { _err }, { root: 1 });
                    commit('setIsLoadingStat', false);
                });
        },
        postStats(context, payload) {
            var item = _.cloneDeep(Cons[0].ACTIVITY)

            item.type = 'stat'
            item.title = 'statistics'
            item.data_type = 'content'

            item.data = {
                stat_type: payload.stat_type,
                item_id: ( payload.stat_type === 'link' || payload.stat_type === 'activity_action' ) ? context.rootGetters['user/brandInfo'].doctor_careplan_id : payload.stat_id,
                brand_id: Cons[0].BRAND_ID
            }

            if( (payload.stat_type === 'activity_action' || payload.stat_type === 'link') && payload.stat_id ) 
                item.data.item_id = payload.stat_id; 
            if( payload.stat_type === 'link' || 
                payload.stat_type === 'activity_link' ||
                payload.stat_type === 'activity_action') 
                item.data.link_tag = payload.link_tag;

            return Axios.post(API.endpoints.careplan + '/' +
                context.rootGetters['user/brandInfo'].brand_default_groups.stats + '/item', item)
                .then(res => {
                    return Promise.resolve(res.data)
                })
                .catch(err => {
                    return Promise.reject(err)
                })
        }
    }
};
